import React from 'react';
import { Link } from 'react-router-dom';
import { pathJoin } from '../../../../../../services/api';
import { capText } from '../../../../../../services/formatting';
import { Add, Edit } from '../../../../../shared/actions/actionButtons';
import { QueryGrid } from '../../../../../shared/grid/queryGrid/queryGrid';
import { CAMPAIGN_ADHOC_TEMPLATE } from '../../../../../../permissions';


export const CampaignAdhocTemplateList = (props) => {

    return <QueryGrid
        queryParamPrefix=''
        singleResourceName='Template'
        pluralResourceName='Templates'
        nameFunction={r => r.name}
        restEndpoint='/communications/campaigns/adhocs/templates'
        listUrl='/communications/campaigns/templates'
        actions={[Add, Edit]}
        readPermissions={[CAMPAIGN_ADHOC_TEMPLATE.READ]}
        writePermissions={[CAMPAIGN_ADHOC_TEMPLATE.WRITE]}
        columns={{
            name: {
                label: 'Name',
                passOnClick: true,
                formatFunction: r => <Link to={pathJoin('/communications/campaigns/templates', r.id)}>{r.name}</Link>,
            },
            message: {
                label: 'Message',
                formatFunction: r => capText(r.message, 100),
            },
            'outboundCallerId': {
                label: 'Caller ID',
                formatFunction: r => r.outboundCallerId && r.outboundCallerId.name + ' ' + r.outboundCallerId.contact,
            },
        }}
        {...props}
    />
}